import { createPersistedState } from "pinia-plugin-persistedstate";
import { $fetch, FetchOptions } from "ofetch";
import { ApiInterface } from "~/repository/api.interface";
import UserClient from "~/repository/client/user.client";
import CampaignClient from "~/repository/client/campaign.client";
import ScodiClient from "~/repository/client/scodi.client";
import DeployClient from "~/repository/client/deploy.client";
import ReportClient from "~/repository/client/report.client";
import PublicClient from "~/repository/client/public.client";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.$pinia.use(createPersistedState());
  const fetchOptions: FetchOptions = {
    baseURL: nuxtApp.$config.public.apiBase,
  };
  const apiFetcher = $fetch.create(fetchOptions);
  nuxtApp.$apiClient = <ApiInterface>{
    user: new UserClient(apiFetcher),
    transmission: new DeployClient(apiFetcher),
    campaign: new CampaignClient(apiFetcher),
    scodi: new ScodiClient(apiFetcher),
    report: new ReportClient(apiFetcher),
    public: new PublicClient(apiFetcher),
  };
});
